export const Asterisk = () => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 5.05285L9.43152 3.12873L5.83979 4.48374L5.96899 0.5H4.05685L4.16021 4.45664L0.594315 3.12873L0 5.05285L3.64341 6.16396L1.31783 9.30759L2.86822 10.5L5.01292 7.16667L7.15762 10.5L8.70801 9.30759L6.38243 6.16396L10 5.05285Z"
      fill="#EB5757"
    />
  </svg>
);
